<template>
  <v-carousel
    cycle
    height="400"
    hide-delimiter-background
    hide-delimiters
    show-arrows-on-hover
  >
    <v-carousel-item>
      <v-sheet
        height="100%"
      >
        <v-row
          class="fill-height"
        >
          <img style="position: relative; top: 50%; transform: translateY(-50%);" width="100%" :src="require('../../../assets/sydney1.jpg')">
          <img class="beCoolLogo" src="../../../assets/BeCool-Logo.png">
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <v-carousel-item>
      <v-sheet
        height="100%"
      >
        <v-row
          class="fill-height"
        >
          <img style="position: relative; top: 50%; transform: translateY(-50%);" width="100%" src="/static/img/nz1.png">
          <img class="beCoolLogo" src="../../../assets/BeCool-Logo.png">
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <v-carousel-item>
      <v-sheet
        height="100%"
      >
        <v-row
          class="fill-height"
        >
          <img style="position: relative; top: 50%; transform: translateY(-50%);" width="100%" :src="require('../../../assets/melbourne.jpg')">
          <img class="beCoolLogo" src="../../../assets/BeCool-Logo.png">
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <v-carousel-item>
      <v-sheet
        height="100%"
      >
        <v-row
          class="fill-height"
        >
          <img style="position: relative; top: 50%; transform: translateY(-50%);" :src="require('../../../assets/perth.jpg')">
          <img class="beCoolLogo" src="../../../assets/BeCool-Logo.png">
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <v-carousel-item>
      <v-sheet
        height="100%"
      >
        <v-row
          class="fill-height"
        >
          <img style="position: relative; top: 50%; transform: translateY(-50%);" width="100%" src="/static/img/nz2.png">
          <img class="beCoolLogo" src="../../../assets/BeCool-Logo.png">
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <v-carousel-item>
      <v-sheet
        height="100%"
      >
        <v-row
          class="fill-height"
        >
          <img style="position: relative; top: 50%; transform: translateY(-50%);" width="100%" :src="require('../../../assets/canberra.jpg')">
          <img class="beCoolLogo" src="../../../assets/BeCool-Logo.png">
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <v-carousel-item>
      <v-sheet
        height="100%"
      >
        <v-row
          class="fill-height"
        >
          <img style="position: relative; top: 50%; transform: translateY(-50%);" width="100%" :src="require('../../../assets/brisbane.jpg')">
          <img class="beCoolLogo" src="../../../assets/BeCool-Logo.png">
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
  // @vuese
  // Carousel for the Home Page
  // @group Home
  export default {
    name: "Carousel"
  }
</script>

<style scoped>

  @media only screen and (min-width: 670px) {

    .beCoolLogo  {
      width: 130px;
      margin-left:-65px;
    }
  }

  @media only screen and (max-width: 670px) {

    .beCoolLogo  {
      width: 100px;
      margin-left:-50px;
    }
  }


  .beCoolLogo {
    position: absolute;
    bottom: 30%;
    left:50%;
  }



</style>



// WEBPACK FOOTER //
// src/components/util/Home/Carousel.vue